// extracted by mini-css-extract-plugin
export default {"likebtn":"Like_likebtn__IggTy"};